import { useArenaSubscriptions } from 'modules/arena/subscriptions/useArenaSubscriptions';
import { StatTile } from 'shared/components/ui/StatTile';
import { PillTabs } from 'shared/components/ui/PillTabs';
import { SubscriptionRow } from 'modules/arena/subscriptions/components/SubscriptionRow';
import { SubscriptionDetailPanel } from 'modules/arena/subscriptions/components/SubscriptionDetailPanel';
import { SUBSCRIPTION_FILTERS } from 'modules/arena/subscriptions/content';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { SkeletonListDetail, SkeletonPills, SkeletonStatGrid } from 'shared/components/ui/Skeleton';

export function ArenaSubscriptionsPage() {
  const {
    subscriptions,
    isLoading,
    error,
    filteredSubscriptions,
    filter,
    setFilter,
    selectedId,
    setSelectedId,
    selectedSubscription,
    chargeNow,
    cancelSubscription,
    reactivateSubscription,
  } = useArenaSubscriptions();

  const activeSubscriptions = subscriptions.filter((s) => s.status === 'ativa');
  const recurringRevenue = activeSubscriptions.reduce((sum, s) => sum + s.monthlyPrice, 0);
  const pendingCount = subscriptions.filter((s) => s.status === 'pendente_pagamento').length;
  const cancelledCount = subscriptions.filter((s) => s.status === 'cancelada').length;

  return (
    <div className="flex-1 p-6">
      <h1 className="font-heading text-xl font-bold text-ink">Assinaturas</h1>
      <p className="text-sm text-ink-secondary">
        Pacotes mensais assinados pelos alunos, cobranças e histórico de pagamento.
      </p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando assinaturas..."
        skeleton={
          <>
            <SkeletonStatGrid />
            <SkeletonPills className="mt-6" widths={[64, 72, 104, 104]} />
            <SkeletonListDetail rows={5} />
          </>
        }
      >
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <StatTile label="Assinaturas ativas" value={String(activeSubscriptions.length)} />
            <StatTile label="Receita recorrente mensal" value={`R$ ${recurringRevenue.toLocaleString('pt-BR')}`} />
            <StatTile label="Pendentes de pagamento" value={String(pendingCount)} />
            <StatTile label="Canceladas" value={String(cancelledCount)} />
          </div>

          <div className="mt-6">
            <PillTabs options={SUBSCRIPTION_FILTERS} value={filter} onChange={setFilter} />
          </div>

          <div className="mt-4 grid gap-6 lg:grid-cols-[1.1fr_1fr]">
            <div className="flex flex-col gap-3">
              {filteredSubscriptions.length === 0 ? (
                <p className="text-sm text-ink-secondary">Nenhuma assinatura com esse status.</p>
              ) : (
                filteredSubscriptions.map((subscription) => (
                  <SubscriptionRow
                    key={subscription.id}
                    subscription={subscription}
                    isSelected={subscription.id === selectedId}
                    onSelect={setSelectedId}
                  />
                ))
              )}
            </div>

            <div className="lg:sticky lg:top-6 lg:self-start">
              {selectedSubscription ? (
                <SubscriptionDetailPanel
                  subscription={selectedSubscription}
                  onChargeNow={chargeNow}
                  onCancel={cancelSubscription}
                  onReactivate={reactivateSubscription}
                />
              ) : (
                <p className="text-sm text-ink-secondary">Selecione uma assinatura para ver os detalhes.</p>
              )}
            </div>
          </div>
      </AsyncSection>
    </div>
  );
}
